import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_ARTICLE,
    getArticleFail,
    getArticleSuccess
} from '../action/getArticleAction'

// api 
import getArticleApi from '../api/getArticleApi'

export function* getArticleSaga(action) {
    try {
        const response = yield call(() => getArticleApi(action.params))
        if (response.data.status === 1) {
            yield put(getArticleSuccess(response, action))
        } else {
            yield put(getArticleFail(response, action))
        }
    }
    catch (e) {
        yield put(getArticleFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_ARTICLE, getArticleSaga)
}